export default __webpack_public_path__ + "static/media/placeholder_blank-en-mobile.d800c675.png";